module.exports = __webpack_public_path__ + "static/media/Entei_gaussian2.5b2a8d0a.png";